var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C8.243 6 6 8.243 6 11V19C6 21.757 8.243 24 11 24H19C21.757 24 24 21.757 24 19V11C24 8.243 21.757 6 19 6H11ZM11 8H19C20.654 8 22 9.346 22 11V19C22 20.654 20.654 22 19 22H11C9.346 22 8 20.654 8 19V11C8 9.346 9.346 8 11 8ZM20 9C19.7348 9 19.4804 9.10536 19.2929 9.29289C19.1054 9.48043 19 9.73478 19 10C19 10.2652 19.1054 10.5196 19.2929 10.7071C19.4804 10.8946 19.7348 11 20 11C20.2652 11 20.5196 10.8946 20.7071 10.7071C20.8946 10.5196 21 10.2652 21 10C21 9.73478 20.8946 9.48043 20.7071 9.29289C20.5196 9.10536 20.2652 9 20 9ZM15 10C12.243 10 10 12.243 10 15C10 17.757 12.243 20 15 20C17.757 20 20 17.757 20 15C20 12.243 17.757 10 15 10ZM15 12C16.654 12 18 13.346 18 15C18 16.654 16.654 18 15 18C13.346 18 12 16.654 12 15C12 13.346 13.346 12 15 12Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.7ee9edc994148e9ecd9d143d2b58e838.svg";
export { ForwardRef as ReactComponent };